import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { loggerService, LogTag } from "@/Utils/LoggerService";

import en from "./translations/en.json";
import fr from "./translations/fr.json";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  })
  .catch((error: unknown) => {
    loggerService.error(LogTag.APP, "i18n initialisation failed", error);
  });

export default i18n;
